// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wDlNDoS0Qbk0rRQwRKPi {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: auto;
  max-width: 700px;
  min-width: 600px;
  height: auto;
  max-height: 80vh;
  overflow-y: auto;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING {
  padding: 24px;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .oU11RmrFIWx8BbpL9_8W {
  width: 100%;
  text-align: center;
  padding: 20px;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .oU11RmrFIWx8BbpL9_8W h3 {
  margin-bottom: 16px;
  color: white;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .YV3dLyZZUpO48cIpXhp0 {
  display: flex;
  align-items: flex-start;
  gap: 24px;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .YV3dLyZZUpO48cIpXhp0 .yUPWAG4vNvstuxrPSXaf {
  flex-shrink: 0;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .YV3dLyZZUpO48cIpXhp0 .yUPWAG4vNvstuxrPSXaf .tmu4FrWYx0Tm20OOW3jp {
  width: 280px;
  height: 210px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
  background-color: #f9fafb;
  position: relative;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .YV3dLyZZUpO48cIpXhp0 .yUPWAG4vNvstuxrPSXaf .tmu4FrWYx0Tm20OOW3jp .tbu7NHpa9LT3G5lbF0AA {
  width: 100%;
  height: 100%;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .YV3dLyZZUpO48cIpXhp0 .yUPWAG4vNvstuxrPSXaf .tmu4FrWYx0Tm20OOW3jp .tbu7NHpa9LT3G5lbF0AA img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .YV3dLyZZUpO48cIpXhp0 .yUPWAG4vNvstuxrPSXaf .tmu4FrWYx0Tm20OOW3jp .cah8YQA9oiJG6ob5Bmv8 {
  position: absolute !important;
  bottom: 8px !important;
  right: 8px !important;
  font-size: 12px !important;
  padding: 6px 12px !important;
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 10;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .YV3dLyZZUpO48cIpXhp0 .yUPWAG4vNvstuxrPSXaf .tmu4FrWYx0Tm20OOW3jp:hover .cah8YQA9oiJG6ob5Bmv8 {
  opacity: 1;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .YV3dLyZZUpO48cIpXhp0 .gXJWdV_T2vKHGdSW4H4U {
  flex: 1;
  padding-top: 4px;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .YV3dLyZZUpO48cIpXhp0 .gXJWdV_T2vKHGdSW4H4U .FkaekYbCLj3z734Y41pB .tIiY9p6WJIopU4oTiNFW {
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
  margin: 0 0 12px 0;
  color: white;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .YV3dLyZZUpO48cIpXhp0 .gXJWdV_T2vKHGdSW4H4U .FkaekYbCLj3z734Y41pB .qOCXQ3NRmIsDG0fjhDPA {
  font-size: 16px;
  color: var(--text-secondary, #6b7280);
  margin-bottom: 8px;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .YV3dLyZZUpO48cIpXhp0 .gXJWdV_T2vKHGdSW4H4U .FkaekYbCLj3z734Y41pB .qOCXQ3NRmIsDG0fjhDPA {
  font-size: 16px;
  color: var(--text-secondary, #6b7280);
  margin-bottom: 8px;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .YV3dLyZZUpO48cIpXhp0 .gXJWdV_T2vKHGdSW4H4U .FkaekYbCLj3z734Y41pB .B8IHBgR95TiJSyenSLq1 {
  font-size: 16px;
  color: var(--text-secondary, #6b7280);
  font-weight: 500;
  transition: color 0.2s ease;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .YV3dLyZZUpO48cIpXhp0 .gXJWdV_T2vKHGdSW4H4U .FkaekYbCLj3z734Y41pB .B8IHBgR95TiJSyenSLq1:hover {
  color: var(--text-primary, #9ca3af);
  text-decoration: underline;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .YV3dLyZZUpO48cIpXhp0 .gXJWdV_T2vKHGdSW4H4U .FkaekYbCLj3z734Y41pB .xKAzKSV_4O89s2NSGa8v {
  font-style: italic;
  opacity: 0.6;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .YV3dLyZZUpO48cIpXhp0 .gXJWdV_T2vKHGdSW4H4U .FkaekYbCLj3z734Y41pB .xKAzKSV_4O89s2NSGa8v:hover {
  text-decoration: none !important;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .rLk6LKEJoIfscuQPAiT3 {
  width: 100%;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .rLk6LKEJoIfscuQPAiT3 .aLeBZpe_0QPtvSCdqQFd {
  display: flex;
  gap: 8px;
  align-items: flex-start;
  width: 100%;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .rLk6LKEJoIfscuQPAiT3 .aLeBZpe_0QPtvSCdqQFd .rsKow8Dqu3QxfwMmy4UJ {
  flex: 1;
  min-width: 0;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  font-family: monospace;
  resize: none;
  background-color: #f9fafb;
  color: #374151;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .rLk6LKEJoIfscuQPAiT3 .aLeBZpe_0QPtvSCdqQFd .rsKow8Dqu3QxfwMmy4UJ:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 1px #3b82f6;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .rLk6LKEJoIfscuQPAiT3 .aLeBZpe_0QPtvSCdqQFd .r3IB2EahfSeDL9ZcGTP2 {
  flex-shrink: 0;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .k4fIpZClGieVZN3IEaj5 {
  width: 100%;
  display: flex;
  gap: 12px;
  justify-content: center;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .k4fIpZClGieVZN3IEaj5 .Bf4KoEoLEBymDxJY3Gtn {
  flex: 1;
  max-width: 200px;
  justify-content: center;
  padding: 10px 16px;
}
.wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .MJwoxA0T3sT2x_3NDEaH .k4fIpZClGieVZN3IEaj5 .Bf4KoEoLEBymDxJY3Gtn svg {
  margin-right: 6px;
}

@media (max-width: 768px) {
  .wDlNDoS0Qbk0rRQwRKPi {
    width: 95vw;
    max-width: none;
    min-width: auto;
  }
  .wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING {
    flex-direction: column;
    gap: 20px;
    padding: 20px;
  }
  .wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .yUPWAG4vNvstuxrPSXaf {
    align-self: center;
  }
  .wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .yUPWAG4vNvstuxrPSXaf .tmu4FrWYx0Tm20OOW3jp {
    width: 100%;
    max-width: 320px;
    height: 240px;
  }
  .wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .yUPWAG4vNvstuxrPSXaf .rLk6LKEJoIfscuQPAiT3 {
    width: 100%;
    max-width: 320px;
  }
  .wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .gXJWdV_T2vKHGdSW4H4U {
    width: 100%;
    text-align: center;
  }
  .wDlNDoS0Qbk0rRQwRKPi .iS6XQukKbu493OA6QING .gXJWdV_T2vKHGdSW4H4U .FkaekYbCLj3z734Y41pB .tIiY9p6WJIopU4oTiNFW {
    font-size: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/editor/components/modals/ShareModal/ShareModal.module.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AAAF;AAEE;EACE,aAAA;AAAJ;AAEI;EACE,WAAA;EACA,kBAAA;EACA,aAAA;AAAN;AAEM;EACE,mBAAA;EACA,YAAA;AAAR;AAII;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAFN;AAIM;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAFR;AAIQ;EACE,cAAA;AAFV;AAIU;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;AAFZ;AAIY;EACE,WAAA;EACA,YAAA;AAFd;AAIc;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAFhB;AAMY;EACE,6BAAA;EACA,sBAAA;EACA,qBAAA;EACA,0BAAA;EACA,4BAAA;EACA,UAAA;EACA,6BAAA;EACA,WAAA;AAJd;AAOY;EACE,UAAA;AALd;AAUQ;EACE,OAAA;EACA,gBAAA;AARV;AAWY;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AATd;AAYY;EACE,eAAA;EACA,qCAAA;EACA,kBAAA;AAVd;AAaY;EACE,eAAA;EACA,qCAAA;EACA,kBAAA;AAXd;AAcY;EACE,eAAA;EACA,qCAAA;EACA,gBAAA;EACA,2BAAA;AAZd;AAcc;EACE,mCAAA;EACA,0BAAA;AAZhB;AAgBY;EACE,kBAAA;EACA,YAAA;AAdd;AAgBc;EACE,gCAAA;AAdhB;AAqBM;EACE,WAAA;AAnBR;AAqBQ;EACE,aAAA;EACA,QAAA;EACA,uBAAA;EACA,WAAA;AAnBV;AAqBU;EACE,OAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,cAAA;AAnBZ;AAqBY;EACE,aAAA;EACA,qBAAA;EACA,6BAAA;AAnBd;AAuBU;EACE,cAAA;AArBZ;AA0BM;EACE,WAAA;EACA,aAAA;EACA,SAAA;EACA,uBAAA;AAxBR;AA0BQ;EACE,OAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AAxBV;AA0BU;EACE,iBAAA;AAxBZ;;AAiCA;EACE;IACE,WAAA;IACA,eAAA;IACA,eAAA;EA9BF;EAgCE;IACE,sBAAA;IACA,SAAA;IACA,aAAA;EA9BJ;EAgCI;IACE,kBAAA;EA9BN;EAgCM;IACE,WAAA;IACA,gBAAA;IACA,aAAA;EA9BR;EAiCM;IACE,WAAA;IACA,gBAAA;EA/BR;EAmCI;IACE,WAAA;IACA,kBAAA;EAjCN;EAoCQ;IACE,eAAA;EAlCV;AACF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shareModalWrapper": `wDlNDoS0Qbk0rRQwRKPi`,
	"wrapper": `iS6XQukKbu493OA6QING`,
	"notShareable": `oU11RmrFIWx8BbpL9_8W`,
	"shareableContent": `MJwoxA0T3sT2x_3NDEaH`,
	"topRow": `YV3dLyZZUpO48cIpXhp0`,
	"leftColumn": `yUPWAG4vNvstuxrPSXaf`,
	"imageWrapper": `tmu4FrWYx0Tm20OOW3jp`,
	"screenshotWrapper": `tbu7NHpa9LT3G5lbF0AA`,
	"changeThumbnailBtn": `cah8YQA9oiJG6ob5Bmv8`,
	"rightColumn": `gXJWdV_T2vKHGdSW4H4U`,
	"sceneDetails": `FkaekYbCLj3z734Y41pB`,
	"sceneTitle": `tIiY9p6WJIopU4oTiNFW`,
	"locationInfo": `qOCXQ3NRmIsDG0fjhDPA`,
	"authorInfo": `B8IHBgR95TiJSyenSLq1`,
	"placeholder": `xKAzKSV_4O89s2NSGa8v`,
	"shareUrlSection": `rLk6LKEJoIfscuQPAiT3`,
	"urlInputWrapper": `aLeBZpe_0QPtvSCdqQFd`,
	"urlTextarea": `rsKow8Dqu3QxfwMmy4UJ`,
	"copyButton": `r3IB2EahfSeDL9ZcGTP2`,
	"shareButtonsSection": `k4fIpZClGieVZN3IEaj5`,
	"shareButton": `Bf4KoEoLEBymDxJY3Gtn`
};
export default ___CSS_LOADER_EXPORT___;
